export function clampPanelPosition(system, panel) {
  if (system.isMobileLayout()) return;

  const style = window.getComputedStyle(panel);
  const matrix = new DOMMatrixReadOnly(style.transform);
  const currentX = matrix.m41;
  const currentY = matrix.m42;

  const wsRect = system.workspace.getBoundingClientRect();
  const parentRect = panel.offsetParent ? panel.offsetParent.getBoundingClientRect() : wsRect;

  const originalLeft = panel.offsetLeft;
  const originalTop = panel.offsetTop;
  const width = panel.offsetWidth;
  const height = panel.offsetHeight;

  const minX = wsRect.left - parentRect.left - originalLeft;
  const maxX = wsRect.right - parentRect.left - originalLeft - width;
  const minY = wsRect.top - parentRect.top - originalTop;
  const maxY = wsRect.bottom - parentRect.top - originalTop - height;

  const clampedX = Math.max(minX, Math.min(maxX, currentX));
  const clampedY = Math.max(minY, Math.min(maxY, currentY));

  if (clampedX !== currentX || clampedY !== currentY) {
    panel.style.transform = `translate(${clampedX}px, ${clampedY}px) translateZ(0)`;
  }
}

export function onPointerDown(system, e) {
  const header = e.currentTarget;
  const panel = header.closest('.panel');
  if (!panel) return;

  if (e.pointerType === 'mouse' && e.button !== 0) return;
  if (system.isMobileLayout()) return;
  if (panel.classList.contains('focused')) return;
  if (e.target.closest('button, select')) return;

  system.bringToFront(panel);

  let width = panel.offsetWidth;
  let height = panel.offsetHeight;
  if (panel.classList.contains('minimized')) {
    panel.classList.remove('minimized');
    width = panel.offsetWidth;
    height = panel.offsetHeight;
    panel.classList.add('minimized');
  }

  system.dragging = {
    panel,
    pointerId: e.pointerId,
    startX: e.clientX,
    startY: e.clientY,
    currentX: 0,
    currentY: 0,
    width,
    height,
  };

  const style = window.getComputedStyle(panel);
  const matrix = new DOMMatrixReadOnly(style.transform);
  system.dragging.currentX = matrix.m41;
  system.dragging.currentY = matrix.m42;

  panel.classList.add('dragging');
  panel.style.willChange = 'transform';
  panel.style.transform = `translate(${system.dragging.currentX}px, ${system.dragging.currentY}px) translateZ(0)`;

  const existingOverlay = document.getElementById('drag-iframe-overlay');
  if (!existingOverlay) {
    const overlay = document.createElement('div');
    overlay.id = 'drag-iframe-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.zIndex = '9999';
    overlay.style.cursor = 'grabbing';
    overlay.style.background = 'transparent';
    document.body.appendChild(overlay);
  }

  e.preventDefault();
}

export function onPointerMove(system, e) {
  if (system.resizing) {
    if (e.pointerId !== system.resizing.pointerId) return;
    system.handleResize(e);
    return;
  }
  if (!system.dragging) return;
  if (e.pointerId !== system.dragging.pointerId) return;

  const dx = e.clientX - system.dragging.startX;
  const dy = e.clientY - system.dragging.startY;

  let newX = system.dragging.currentX + dx;
  let newY = system.dragging.currentY + dy;

  const wsRect = system.workspace.getBoundingClientRect();
  const parentRect = system.dragging.panel.offsetParent ? system.dragging.panel.offsetParent.getBoundingClientRect() : wsRect;

  const originalLeft = system.dragging.panel.offsetLeft;
  const originalTop = system.dragging.panel.offsetTop;
  const width = system.dragging.width;

  const minX = wsRect.left - parentRect.left - originalLeft;
  const maxX = wsRect.right - parentRect.left - originalLeft - width;
  const minY = wsRect.top - parentRect.top - originalTop;
  const maxY = wsRect.bottom - parentRect.top - originalTop - 40;

  newX = Math.max(minX, Math.min(maxX, newX));
  newY = Math.max(minY, Math.min(maxY, newY));

  system.dragging.panel.style.transform = `translate(${newX}px, ${newY}px) translateZ(0)`;

  system.currentTranslateX = newX;
  system.currentTranslateY = newY;
}

export function onPointerUp(system, e) {
  if (system.resizing) {
    if (e.pointerId !== system.resizing.pointerId) return;
    const panel = system.resizing.panel;
    panel.classList.remove('resizing-active');
    panel.style.willChange = '';

    const overlay = document.getElementById('resize-iframe-overlay');
    if (overlay) overlay.remove();

    system.resizing = null;
    system.saveLayout();
    return;
  }
  if (!system.dragging) return;
  if (e.pointerId !== system.dragging.pointerId) return;

  const panel = system.dragging.panel;
  panel.classList.remove('dragging');

  panel.style.willChange = 'auto';

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (!panel.classList.contains('dragging')) {
        panel.style.willChange = '';
      }
    });
  });

  const overlay = document.getElementById('drag-iframe-overlay');
  if (overlay) {
    overlay.remove();
  }

  system.dragging = null;
  system.saveLayout();
}
